import React from 'react';
import cn from 'classnames';
import {SelectOptionType} from '../../../utils/types';
import Button from 'components/acommon/Button';
import styles from './styles.module.sass';

export type IdentityTypeSelectorItem = {
  label: string;
  value: SelectOptionType | string;
  onClick: () => void;
  isDisabled?: boolean;
};

export type IdentityTypeSelectorProps = {
  title: string;
  items?: IdentityTypeSelectorItem[];
  onAction?: () => void;
  actionLabel?: string;
  value?: string | SelectOptionType;
};

function IdentityTypeSelector({
  title,
  onAction,
  actionLabel,
  items,
  value: selectedValue,
}: IdentityTypeSelectorProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      <div className={styles.itemsList}>
        {items?.map(({label, onClick, value}, key) => {
          const isActive =
            typeof selectedValue === 'string'
              ? selectedValue === value
              : selectedValue?.value === value;

          return (
            <div
              key={key}
              className={cn(styles.item, {[styles.active]: isActive})}
              onClick={onClick}
            >
              <div className={styles.itemLabel}>{label}</div>
              {onAction && (
                <Button
                  className={styles.itemAction}
                  onClick={onAction}
                  type="button"
                  rightIcon="arrow-next"
                  size="medium"
                >
                  {actionLabel}
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export {IdentityTypeSelector};
